<template>
  <transition @enter="enter" @leave="leave" appear>
    <div class="Share">  
      <div class="Share__description">
        <div class="Share__title" v-html="trans('GLOBAL.sure')"/>
        <div class="Share__desc" v-html="trans('GLOBAL.returning')"/>
      </div>
      <div class="Share__buttons">
        <div class="Button small" @click="onClick('no')">{{ trans('GLOBAL.no') }}</div>
        <div class="Button small" @click="onClick('yes')">{{ trans('GLOBAL.yes') }}</div>
      </div>
    </div> 
  </transition>
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Share',
  beforeDestroy() {
    this.$store.commit('app/UPDATE_STATUS', 'close_sharing')
  },
  methods:{  
    onClick(arg) {
      if(arg == 'no')
        this.$router.push({ params: { step: undefined } })
      else {

        console.log('YES!!!');

        this.$store.commit('app/UPDATE_STATUS', 'sharing')
        // this.$router.push({ params: { section: 'finish', step: undefined } })
      }
    },

    submit() {
      // const formData = new FormData();
        //       formData.append('plaintext', 'Joe Bean');

        // axios({
        //     method: 'post',
        //     url: 'https://api.wbloomdev.com/api/post/ugc',
        //     data: formData,
        //     headers: {  
        //         'api-key': 'J7LTPxyAhqEXxkuqF7aJRA', 
        //         'Content-Type': 'multipart/form-data' }
        //     })
        //     .then(function (res) {
        //         console.log(res);
        //     })

        // axios({
        //     method: 'get',
        //     url: 'https://api.wbloomdev.com/api/get/ugc',
        //     headers: {  'api-key': 'J7LTPxyAhqEXxkuqF7aJRA' }
        //     })
        //     .then(function (res) {
        //         console.log(res);
        //     })
    },




    enter(el, done) {
      gsap.from(this.$el, { 
        duration: .5, 
        opacity: 0, 
        ease: 'none', 
        delay: .25, 
        onComplete: ()=> done() 
      })

    },
    leave(el, done) {
      done()
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Share
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content center
  align-items center
  text-align center

  &__description 
    width 81vw
    height 21.5vh

    background purple

    // background rgb(118, 84, 191)
    // background linear-gradient(0deg, rgba(118, 84, 191, 1) 34%, rgba(147, 108, 207, 1) 100%)

    margin 2vh 0
    border-radius 16px
    display flex
    flex-direction column
    align-items center
    justify-content center
    font-size 22px

  &__title  
    font-family SpaceGrotesk
    font-size 30px
    line-height 20px
    padding 20px 0

    & span 
      font-weight 900

  &__desc  
    font-family Raleway
    font-size 15px
    line-height 20px

  &__buttons 
    display flex 
    justify-content space-between
    width 81vw

</style>


